(function() {
    'use strict';

    angular
        .module('app.layout')
        .directive('contactsSelector', dir)
        .filter('truthyProps', function() {
            return function(obj) {
                var res = {};
                for (var prop in obj) {
                    if (obj[prop]) {
                        res[prop] = obj[prop];
                    }
                }
                return res;
            };
        });

    /* @ngInject */
    function dir($http, $cookies) {
        var conf = {
            templateUrl: 'contacts-selector.tpl',
            bindToController: true,
            controller: ctrl,
            controllerAs: 'vm',
            link: link,
            restrict: 'E',
            require: '?ngModel',
            scope: {
                data: '<'
            }
        };
        return conf;

        function link(scope, element, attrs, ngModel) {
            if(!ngModel) { return; } // do nothing if no ng-model
            var _gPeopleApiSettings = scope.$root.globals.site_options.google_people_api_settings;
            // var _gSignedIn = false;

            scope.vm.showResultsFor = '';
            scope.vm.contactsSearchText = '';
            scope.vm.error = null;
            scope.vm.contacts = {
                // gmail: _data.filter(function(c) { return c.name && c.email; }),
                selected: {},
                gmail: null,
                outlook: [],
                yahoo: null
            };


            // API key and client ID must be defined in site settings to enable gmail contacts
            if (_gPeopleApiSettings['api-key'] && _gPeopleApiSettings['client-id']) {
                initGMailContacts();
            }
            function initGMailContacts() {
                var apiKey = _gPeopleApiSettings['api-key'].trim();
                var clientId = _gPeopleApiSettings['client-id'].trim();
                var script = document.createElement('script');
                script.type = 'text/javascript';

                function initClient() {
                    gapi.client.init({
                        apiKey: apiKey,
                        clientId: clientId,
                        discoveryDocs: ["https://www.googleapis.com/discovery/v1/apis/people/v1/rest"],
                        scope: "https://www.googleapis.com/auth/contacts.readonly"
                    }).then(function() {
                        // do nothing...
                    }).catch(function(err) {
                        scope.vm.error = 'Initialize google People API failed';
                    });
                }

                script.onload = function() { gapi.load('client:auth2', initClient); };
                script.src = 'https://apis.google.com/js/api.js';
                document.body.appendChild(script);

            }

            function loadGmailContacts(isSignedIn) {
                if (isSignedIn !== true) { return; }

                gapi.client.people.people.connections.list({
                    'resourceName': 'people/me',
                    'pageSize': 999,
                    'personFields': 'names,emailAddresses'
                }).then(function(response) {
                    var connections = response.result.connections;
                    var contacts = [];
                    angular.forEach(connections, function(p) {
                        if (
                            angular.isArray(p.names) && p.names.length > 0 &&
                            angular.isArray(p.emailAddresses) && p.emailAddresses.length > 0
                        ) {
                            contacts.push({
                                name: p.names[0].displayName,
                                email: p.emailAddresses[0].value
                            });
                        }
                    });

                    if (contacts.length > 0) {
                        scope.vm.contacts.gmail = contacts;
                        scope.vm.showResultsFor = 'gmail';
                        scope.safeApply();
                    }
                });
            }

            scope.safeApply = function(fn) {
                var phase = this.$root.$$phase;
                if(phase == '$apply' || phase == '$digest') {
                    if(fn) {
                        fn();
                    }
                } else {
                    this.$apply(fn);
                }
            };

            scope.unselectContact = function (event, key) {
                event.preventDefault();
                event.stopPropagation();
                scope.vm.contacts.selected[key] = false;
            };

            scope.getGmailContacts = function(event) {
                event.preventDefault();
                event.stopPropagation();
                scope.vm.error = null;

                if (Array.isArray(scope.vm.contacts.gmail) && scope.vm.contacts.gmail.length > 0) {
                    scope.vm.showResultsFor = 'gmail';
                    return;
                }

                gapi.auth2.getAuthInstance().signIn().then(function(res) {
                    loadGmailContacts(true);
                }).catch(function(err) {
                    console.log(err);
                    scope.vm.error = "User authorization failed";
                });
            };



            // scope.getGmailContactsX = function(event) {
            //     event.preventDefault();
            //     event.stopPropagation();
            //     scope.vm.error = null;

            //     // check if concatcs already loaded
            //     if (Array.isArray(scope.vm.contacts.gmail) && scope.vm.contacts.gmail.length > 0) {
            //         scope.vm.showResultsFor = 'gmail';
            //         return;
            //     }

            //     $http({
            //         method: 'POST',
            //         url: ajaxurl,
            //         data: { action: 'gmail_action' }
            //     }).then(
            //         function(res) {

            //             if (res.data.error === "missing access token" || res.data.error === "require auth") {
            //                 var today = new Date();
            //                 var expiresValue = new Date(today);
            //                 expiresValue.setMinutes(today.getMinutes() + 5);
            //                 $cookies.put('oauth_back_uri', window.location.href, {
            //                     'expires' : expiresValue,
            //                     'path': '/'
            //                 });
            //                 window.location.href = "/gmail-contacts/";
            //             } else if (Array.isArray(res.data)) {
            //                 // filter contacts with existing name and email address
            //                 scope.vm.contacts.gmail = res.data.filter(function(c) {
            //                     return c.name && c.email;
            //                 });
            //                 scope.vm.showResultsFor = 'gmail';
            //             } else {
            //                 scope.vm.error = 'loading contacts failed';
            //             }
            //         }

            //     ).catch(function(err) {
            //         scope.vm.error = 'loading contacts failed';
            //     });

            // };

            scope.$watch(
                function() {
                    return scope.vm.contacts.selected;
                }, function(newValue) {
                    var emails = [];
                    angular.forEach(newValue, function(value, key) {
                        if (value) {
                            emails.push(key);
                        }
                    });
                    ngModel.$setViewValue(emails.join(','));
                }, true
            );

            scope.closeResults = function(event) {
                event.preventDefault();
                event.stopPropagation();
                scope.vm.showResultsFor = '';
                scope.vm.contactsSearchText = '';
            };
            scope.fetchOutlookContacts();

        } // link
    } // dir


    /* @ngInject */
    function ctrl($scope, $http, $cookies) {
        $scope.getOutlookContacts = function(e) {
            if ($scope.vm.contacts.outlook.length > 0) {
                $scope.vm.showResultsFor = 'outlook';
                return false;
            } else {
                window.open($scope.vm.outlookAuthLink, 'popup', 'width=600, height=600,left=' + parseInt($scope.$root.win.width / 2 - 300));
            }
            return false;
        };

        $scope.getAbookContacts = function(e) {
            $scope.vm.showResultsFor = 'abook';
            var adata = {
                action: 'pie_action',
                method: 'abook_contacts_list',
                nonce: $scope.$root.stats.nonce,
                params: {
                    seller_id: $scope.vm.data.seller_id
                }
            };

            $http.post(window.ajaxurl, adata).then(function(r) {
                if (r.data.result == true) {
                    $scope.vm.contacts.abook = r.data.payload.contacts;
                }
            });

        };
        $scope.getBbookContacts = function(e) {
            $scope.vm.showResultsFor = 'bbook';
            var adata = {
                action: 'pie_action',
                method: 'bbook_contacts_list',
                nonce: $scope.$root.stats.nonce,
                params: {
                    seller_id: $scope.vm.data.seller_id
                }
            };

            $http.post(window.ajaxurl, adata).then(function(r) {
                if (r.data.result == true) {
                    if (r.data.payload.contacts.length) {
                        $scope.vm.contacts.bbook = r.data.payload.contacts;
                    }
                }
            });

        };
        $scope.getEmailById = function(id) {
            return $scope.vm.contacts.bbook.find(function(e) {
                return e.id == id;
            }).email;
        };
        $scope.fetchOutlookContacts = function() {
            var adata = {
                action: 'outlook_data',
                nonce: $scope.$root.stats.nonce
            };

            $http.post(window.ajaxurl, adata).then(function(r) {
                if (r.data.result == true) {
                    $scope.vm.contacts.outlook = r.data.outlookData.contacts;
                } else if (angular.isDefined(r.data.link)) {
                    $scope.vm.outlookAuthLink = r.data.link;
                }
            });
        };

        $scope.showContacts = function(outlookData) {
            $scope.vm.contacts.outlook = outlookData.contacts;
            $scope.vm.showResultsFor = 'outlook';
            $scope.safeApply();
        };

        window.popUpCallback = function(r) {
            $scope.showContacts(r.outlookData);
        };

    } // ctrl

})();
